export const typography = {
  fonts: {
    heading: `Open Sans, Geneva, Verdana, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol`,
    body: `Open Sans, Geneva, Verdana, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol`,
    mono: `Operator Mono, Fira Code Retina, Bitstream Vera Sans Mono, ui-monospace, Menlo, Monaco, Cascadia Mono, Segoe UI Mono, Roboto Mono, Oxygen Mono, Ubuntu Monospace,Source Code Pro, Fira Mono, Droid Sans Mono, Courier New, monospace`,
  },
  fontSizes: {
    '3xs': '0.625rem',
    '2xs': '0.78125rem',
    xs: '0.875rem',
    sm: '0.9375rem',
    md: '1.0625rem',
    lg: '1.3125rem',
    xl: '1.75rem',
    '2xl': '2.125rem',
    '3xl': '2.9375rem',
    '4xl': '3.625rem',
    '5xl': '4.9375rem',
    '6xl': '6rem',
  },
  lineHeights: {
    '3xs': '160%',
    '2xs': '160%',
    xs: '142.9%',
    sm: '160%',
    md: '141.2%',
    lg: '152.4%',
    xl: '142.9%',
    '2xl': '129.4%',
    '3xl': '102.1%',
    '4xl': '117.2%',
    '5xl': '121.5%',
    '6xl': '125%',
  },
  letterSpacings: {
    '3xs': '0.012em',
    '2xs': '0em',
    xs: '-0.0014em',
    sm: '-0.002em',
    md: '-0.0026em',
    lg: '-0.01em',
    xl: '-0.012em',
    '2xl': '-0.015em',
    '3xl': '-0.017em',
    '4xl': '-0.015em',
    '5xl': '-0.007em',
    '6xl': '-0.013em',
    allCaps: '0.1em',
  },
}
